import Service from "./Service";
import {SERVER_URL} from "../utils/Constants";
import GeneralUtils from "../utils/GeneralUtils";

export class SubcategoryService extends Service{
    constructor() {
        super();
        this.baseURL = 'subcategory';
    }

    findByCategoryId(categoryId) {
        return fetch(SERVER_URL + this.baseURL + '/findByCategoryId/' + categoryId, {
            headers: {'Content-Type': 'application/json', Authorization: localStorage.getItem("Authorization")}
        }).then(response => response.json()).catch(error => {
            GeneralUtils.notification(error);
        });
    }
}